import React from "react";
import ReactDom from "react-dom";
import { lib } from "react-single-app";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./page/app";

const { platformCode, systemCode, envCode } = BUILD_CONFIG;
lib.setConfig(
    {
        webToken: location.pathname.includes("admin") ? "admin" : "user",
        env: envCode,
    },
    {
        platformCode,
        systemCode,
        envCode,
    },
);

ReactDom.render(
    <Router>
        <App />
    </Router>,
    document.getElementById("app"),
);
